<ng-container *ngIf="showLoading">
<!--头部-->
<component-header *ngIf="page!=='finish' && exerciseGroup " [isOpenClass]="isOpenClass" [theme]="'sight'" [headTitle]="headTitle" (onReturn)="exit()"></component-header>
<div class="head-right-btn" *ngIf="exerciseGroup && exerciseGroup['backgroundDescription']&&( exerciseGroup.status == 10 && page=='list' || page=='answer') " (click)="backgroundDesc()" ><span class="tit">背景描述</span><span class="triangle" [ngClass]="isShowBackDesc? 'up' : 'down' "></span></div>
<!-- 背景描述 -->
<div class="mask" *ngIf="isShowBackDesc">
  <div class="inner" *ngIf="exerciseGroup">
    <p class="inner_title" >{{exerciseGroup.homeworkTitle.indexOf("-")!= -1 ? exerciseGroup.homeworkTitle.split("-")[0] : exerciseGroup.homeworkTitle}}</p>
    <div class="sceneInner">{{exerciseGroup['backgroundDescription']}}</div>
  </div>
  <div class="up"></div>
</div>
<!--作业簿主体-->
<div class="exercise-work-wrap " *ngIf="exerciseGroup && page!=='finish'">
  <p class="title" *ngIf="exerciseGroup.status == 0">{{exerciseGroup.homeworkTitle.indexOf("-")!= -1 ? exerciseGroup.homeworkTitle.split("-")[0] : exerciseGroup.homeworkTitle}}</p>
  <p class="blank" *ngIf="exerciseGroup.status == 10"></p>
<!--收拢展开-->
    <!--  单元列表-->
    <div class="exercise-work-body" [ngStyle]="{'top': exerciseGroup.status === 0 ?  exerciseGroup.homeworkTitle.length > 19 ? '2.5rem' : '2rem' : '1.2rem' }" [ngClass]="{'list-style': page==='list','answer-style':page==='answer'}"  *ngIf="exerciseGroup">
      <p class="content" *ngIf="page === 'list' && exerciseGroup['backgroundDescription'] && (exerciseGroup.status === 0 && ( !this.uploadList || this.uploadList && this.uploadList.length === 0))" [innerHtml]="exerciseGroup['backgroundDescription']" ></p>
      <div class="myAnswer" *ngIf="page === 'list' && exerciseGroup.status >= 10">我的作答</div>
      <div class="exercise-wrap" [ngClass]=" { 'answer' : page === 'answer' , 'list' : page === 'list' &&  exerciseGroup.status >= 10} " >
        <div class="exercise-item-wrap-{{page}} active" id="exercise-item-wrap-active">
          <div class="itemlist" *ngIf="page === 'list' && exerciseGroup.status >= 10">
            <app-work-item [uploadList]="uploadList" [uploadDisabled]="uploadDisabled" [exerciseType]="exerciseType" [isShowMsg]="isShowMsg" [pdfList]="pdfList" [lpmapcId]="lpmapcId" [question]="exerciseGroup" [page]="page" (outPutData)="getPostData($event)" (outPutDownload)="downloadPDF($event)" (outPutDelFile)="deleteUploadFile($event)" (outPutCanSave)="getCanSave($event)" (outPutPreview)="showReview($event)"></app-work-item>
          </div>
          <div class="answer" *ngIf="page === 'answer'">
            <app-work-item [uploadList]="uploadList" [uploadDisabled]="uploadDisabled" [exerciseType]="exerciseType" [isShowMsg]="isShowMsg" [pdfList]="pdfList" [lpmapcId]="lpmapcId" [question]="exerciseGroup" [page]="page" (outPutData)="getPostData($event)" (outPutDownload)="downloadPDF($event)" (outPutDelFile)="deleteUploadFile($event)" (outPutCanSave)="getCanSave($event)" (outPutFileLoad)="fileUpload($event)" (outPutPreview)="showReview($event)"></app-work-item>
          </div>

        </div>
      </div>

    </div>

  <!-- 上下题目切换 -->
  <div class="btnStation" id="btnStation" *ngIf="page === 'answer'">
    <div class="disableNextQuestion" id="arrowRightGray" *ngIf="currentNumber !== allQuestionsNumber && !isNextQuestion" ></div>
    <div class="drawSave" [ngClass]="{'disable' : blankSave}" (click)="saveAnswer('answer')"></div>
    <div class="submit" *ngIf="currentNumber === allQuestionsNumber" (click)="commitAnswer(0)"></div>
  </div>

<!--  提交按钮-->
  <div class="exercise-work-commit" *ngIf="page==='list'">
    <div class="exercise-work-btn" *ngIf="exerciseGroup.status == 0 && ( !this.uploadList || this.uploadList && this.uploadList.length === 0)" (click)="goAnswer(0)">{{buttonTxt}}</div>
    <div class="exercise-btn normalHollow" *ngIf="exerciseGroup.status == 10 || this.uploadList && this.uploadList.length > 0 " (click)="goAnswer(1)">编辑</div>
    <div class="exercise-btn normalSolid" *ngIf="exerciseGroup.status == 10 ||  this.uploadList && this.uploadList.length > 0" (click)="commitAnswer(1)">提交</div>
  </div>
</div>

<!--loading-->
<div class="exercise-work-loading" *ngIf="isShowLoading">
  <img class="loading" src="{{assetsRoute}}/picture/Loading.gif" alt="" />
  <p class="loading-txt">保存中...</p>
</div>

<div class="exercise-work-cover" *ngIf="isShowPopup">
  <div class="exercise-work-close" (click)="closePopup()"></div>
  <div class="exercise-work-popup" [ngClass]="{'in': isPopupEnter}">
    <p class="popup-toast">提交后不可再修改，请确认已完成。</p>
    <div class="popup-btn" (click)="tipsContinue()">确认提交</div>
  </div>
</div>

</ng-container>

<!--预览-->
<app-work-preview *ngIf="isShowPreview" [previewSource]="previewSource" (outPutClosePreview)="closePreview()"></app-work-preview>
<!--提示框-->
<app-com-tip *ngIf="isShowToast" [theme]="toastType === 2 ? 'circle' : 'default'" [type]="'toast'" [desText]="toastType === 0 ? '请完成所有题目再提交~' : toastType === 1 ? '请填写空白的步骤再提交~' : toastType === 3 ? '保存成功': toastType === 2 ? errTxt : toastType ===4 ?'输入已达到上限':'' " [cancelText]="''" [sureText]="''" ></app-com-tip>
<!--未完成提示框-->
<component-tip *ngIf="isShowFinishTip" [desText]=" '任务还未完成，<br>确认要退出吗？' " [sureText]="'退出'" [cancelText]="'继续'" [returnType]="0" (onSure)="unFinishExit()" (onCancel)="continue()"></component-tip>
<!--弹出框-->
<app-com-tip *ngIf="isShowTip" (outPutPrivate)="getUserOpenFlag($event)"  (onCancel)="tipsContinue()" (onSure)="closeComponentTip()" [theme]="'sight'" [type]="'tip'" [desText]="'需要保存你的作答么？'" [cancelText]="'保存'" [sureText]="'不保存'" ></app-com-tip>
<!--提交成功-->
<app-work-finish *ngIf="page==='finish'" [isNeedCorrect]="isNeedCorrect" (finishAnswer)="finishExercise($event)"></app-work-finish>
<app-loading-component *ngIf="!showLoading"></app-loading-component>


// WEBPACK FOOTER //
// ./src/app/app-home-work/home-work.component.html